// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import ReloadBookingsController from "./reload_bookings_controller"
application.register("reload-bookings", ReloadBookingsController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TippyController from "./tippy_controller"
application.register("tippy", TippyController)

import TrInteractiveController from "./tr_interactive_controller"
application.register("tr-interactive", TrInteractiveController)
